// Brief Jun 15 §1 (post-MaIA GaaS) — Global SkillPill component.
//
// Single source of truth for the flat skill pill style across the platform :
//   • ProfileSidebar (sidebar Compétences)
//   • ProfileHeader (hero pills)
//   • Discover expert cards
//   • MaIA expert cards (/app/assistant)
//   • Anywhere else skills/expertise are rendered
//
// Uses design tokens only (no hardcoded hex) so light + dark adapt automatically.
import React from 'react';

export const SkillPill = ({ children, className = '', testId, onClick, size = 'sm' }) => {
  const sizeStyles = size === 'xs'
    ? { fontSize: '11px', padding: '2px 8px' }
    : { fontSize: '12px', padding: '4px 10px' };
  const Comp = onClick ? 'button' : 'span';
  return (
    <Comp
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`inline-flex items-center font-medium leading-tight ${className}`}
      style={{
        background: 'var(--color-background-secondary)',
        border: '0.5px solid var(--color-border-tertiary)',
        borderRadius: 'var(--border-radius-md)',
        color: 'var(--color-text-secondary)',
        cursor: onClick ? 'pointer' : 'default',
        ...sizeStyles,
      }}
      data-testid={testId}
    >
      {children}
    </Comp>
  );
};

export default SkillPill;
